// Angular
import { Component, Input, OnInit, ViewChild } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { AuthService, currentUser, Logout, User } from '../../../../../core/auth';
import { NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
    selector: 'kt-user-profile',
    templateUrl: './user-profile.component.html',
    styles: [`
	.kt-badge--unified-success {
        color: #005BAA;
        background: rgb(93, 120, 255, 0.1)
	  }
	  .outbutton:hover{
		  color: #ffffff!important;
	  }
	`]
})
export class UserProfileComponent implements OnInit {
    // Public properties
    user$: Observable<User>;
	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    @Input() avatar = true;
    @Input() greeting = true;
    @Input() badge: boolean;
    @Input() icon: boolean;

    @ViewChild(NgbDropdownMenu) caseCodeDropdown: NgbDropdownMenu;

    /**
     * Component constructor
     *
     * @param store: Store<AppState>
     */
    constructor(
        private store: Store<AppState>,
        private authService: AuthService
    ) {
    }

    /**
     * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
     */

    /**
     * On init
     */
    ngOnInit(): void {
        this.user$ = this.store.pipe(select(currentUser));
    }

    /**
     * Log out
     */
    logout() {
        this.authService.logout(null, true)
            .subscribe(logoutDone => {
                if (logoutDone) {
                    this.store.dispatch(new Logout());
                }
            });
    }

    /**
     * Close dropdown
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-08-27
     */
    close() {
        this.caseCodeDropdown.dropdown.close();
    }
}
